import React, {FC} from 'react';

import {Trans} from '../../../../libs/shared/core/src/helpers/internationalization/react';
import {ChiliPiperProductionRoutersEnum} from '../../../../libs/shared/core/src/services/chilipiper/chilipiper';
import {ChiliPiperDialog} from './chiliPiperDialog';

/*
 * Props.
 */

interface ScaleUpsellChiliPiperDialogProps {
  onRequestClose: () => void;
}

/*
 * Component.
 */

export const ScaleUpsellChiliPiperDialog: FC<ScaleUpsellChiliPiperDialogProps> = (props) => (
  <ChiliPiperDialog
    title={<Trans id="scaleupsellchilipiperdialog-title">Talk to sales</Trans>}
    router={ChiliPiperProductionRoutersEnum.SCALE_UPSELL}
    onRequestClose={props.onRequestClose}
  />
);
